<template>
  <div class="em-trans-panel">
    <div style="display:flex; align-items: center;justify-content:space-between;margin-bottom:16px;">
      <div class="btn-lab">
        <sw-button
          :custom-button-size="9"
          type="primary"
          icon="su-icon-plus"
          @click.stop="show_add_org_panel()"
        >新增组织结构&用户组</sw-button>
        <!-- <sw-button :custom-button-size="9" :disabled="select_arr.length===0" icon="su-icon-delete" simple @click.stop="show_add_user=false">删 除</sw-button> -->
      </div>
      <div class="sea-lab">
        <el-input
          v-model.trim="keyword_has"
          clearable
          placeholder="请输入机构/用户组"
          @change="search_handle()"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search_handle()"
          />
        </el-input>
        <sw-button
          :custom-button-size="8"
          type="primary"
          icon="su-icon-renew"
          @click="clear_search"
        />
      </div>
    </div>
    <div style="position:relative;margin-bottom:20x;overflow-y:auto;height:calc(100vh - 250px)">
      <sw-table
        v-loading="!show_has_tab"
        :table-name="'org-tab'"
        :table-data="org_data"
        :table-title="tableTitle"
        :has-operation="true"
        :page-sizes="table_size"
        :total-count="total_count"
        :page-size="10"
        :table-operation="tableOperation"
        :has-add-button="false"
        :show-selection="false"
        @selection-change="select_change"
        @operation-handle="operationHandle"
        @change-page="change_page"
        @size-change="size_change"
      />
    </div>
    <sw-slide-dialog
      :visible.sync="show_add"
      :width="'648px'"
      title="新增组织结构&用户组"
    >
      <div class="mgt-20 org-tab">
        <table v-loading="!show_org">
          <tr>
            <th width="47%">组织机构</th>
            <th width="47%">用户组</th>
            <th width="6%">
              <div style="font-size:12px;white-space:nowrap;">删除</div>
              <!-- <div><sw-button type="primary" icon="su-icon-plus" circle @click="show_add_org_role=true"/></div> -->
            </th>
          </tr>
          <tr
            v-for="(item,index) in arr_org_ug"
            :key="index"
          >
            <td width="47%">{{ item.org.title }}</td>
            <td width="47%">{{ item.role.title }}</td>
            <td width="6%">
              <div><i
                  class="su-icon-circle-minus"
                  style="font-size:22px;color:red;cursor: pointer;"
                  @click.stop="del_org_role(index)"
                /></div>
            </td>
          </tr>
        </table>
        <div
          v-if="show_org"
          class="org-select"
        >
          <div
            v-loading="!show_org"
            class="org-select-cell non-first"
          >
            <sw-select
              ref="opt_1"
              :disabled="org_sel_disabled"
              v-model="sw3_select.zj"
              placeholder="请选择组织机构"
              @visible-change="visible_change"
            >
              <sw-option
                v-for="item in data.nav_list3[1]"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
              <template>
                <sw-tree
                  v-if="show_tree"
                  :data="data.nav_list3[1]"
                  :props="defaultProps"
                  @node-click="node_click"
                />
              </template>
            </sw-select>
          </div>
          <div class="org-select-cell">
            <el-select
              v-model="sw3_select.ug"
              filterable
              placeholder="请选择用户组"
              @change="chang_user_group"
            >
              <el-option
                v-for="item in data.nav_list3[0]"
                :key="item.id"
                :label="item.title"
                :value="item.id"
                style="width:300px;"
              />
            </el-select>
          </div>
          <!-- <span @click.stop="push_org_role()">确定</span> -->
        </div>
      </div>
      <span slot="footer">
        <sw-button
          :custom-button-size="9"
          @click="show_add=!show_add"
        >取 消</sw-button>
        <sw-button
          :loading="btn_loading"
          :custom-button-size="9"
          type="primary"
          @click="add_athu()"
        >确 定</sw-button>
      </span>
    </sw-slide-dialog>
  </div>
</template>
<script>
import { parseTime } from '@/utils/index'
import service from '@/utils/service'
export default {
  data () {
    return {
      data: {},
      data_list: [[], []],
      user_choose: [], // 选择人员数组
      search_user_tag: false, // 用户搜索标志位
      selectlist: [],
      keyword_user_group: '',
      keyword_org: '',
      sw1_no_more: false,

      show_org: false,
      show_sw1: false,
      show_add: false,
      org_data: [], // 已授权列表
      tableTitle: '', // 表头
      total_count: '', // 列表总条数
      tableOperation: '', // 操作
      select_arr: [], // 已选列表
      pageSize: 10,
      page: 1,
      timeout: '',
      //   current: 0,
      //   keys: ['组织机构', '用户组'],

      sw3_select: { zj: '', ug: '' }, // 组织机构应用组选择框绑定字样
      defaultProps: { children: 'children', label: 'title' },
      org_ug: { org: '', role: '' }, // 当前选择的组织机构和用户组id
      show_tree: true,
      arr_org_ug: [],
      show_add_org_role: false,
      show_has_tab: false,
      keyword_has: '',
      btn_loading: false,

      org_sel_disabled: false

    }
  },
  computed: {
    table_size () {
      return this.$store.state.app.tableSize
    }
  },
  watch: {
    'keyword_user_group': function (newVal) {
      this.search_user_tag = true
      this.search_group_lan()()
    }
  },
  created () {
    this.tab_init()
  },
  methods: {
    // 表单数据初始化
    tab_init () {
      // tab2表头
      this.tableTitle = [
        { prop: 'ins_name', label: '组织机构名称', width: '120', sortable: true },
        { prop: 'group_name', label: '用户组名称', width: '120', sortable: true },
        { prop: 'creator', label: '授权人', width: '120', sortable: true },
        { prop: 'create_time', label: '操作时间', width: '154', sortable: true }
      ]
      // tab2操作
      this.tableOperation = [
        { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
      ]
      this.limit = this.table_size[0]
      this.get_has_org(1)
    },
    get_has_org (page) {
      var param = {
        og: this.keyword_has,
        appId: this.$route.params.fid,
        page: page,
        limit: this.pageSize
      }
      this.show_has_tab = false
      service.get('/v1/appAccess/queryAuthOgsList', { params: param }).then((res) => {
        if (res.data) {
          this.org_data = res.data.map(item => {
            item.create_time = parseTime(item.create_time)
            return item
          })
        } else {
          this.org_data = []
        }
        this.total_count = res.count
        this.show_has_tab = true
      }).catch(res => {
        this.$swMessage({
          message: res,
          type: 'error'
        })
      })
    },
    // 选择
    select_change (sel) {
      this.select_arr = sel
    },
    // 切换页面
    change_page (page) {
      this.get_has_org(page)
    },
    // 切换表格数据显示大小
    size_change (size) {
      this.pageSize = size
      this.get_has_org(1)
    },
    // 列表操作设置
    operationHandle (id, operation) {
      if (this[`${operation}Handle`]) {
        this[`${operation}Handle`](id)
      }
    },
    // 删除操作
    deleteHandle (id) {
      var selUser = {}
      this.org_data.some(u => {
        if (u.id === id) {
          selUser = u
          return true
        }
      })
      var param = {
        id: selUser.id,
        type: 'ogs'
      }
      service.get('/v1/appAccess/deleteAccessAuth', { params: param }).then((res) => {
        this.show_has_tab = false
        this.get_has_org(1)
        this.$swMessage({
          message: `删除${selUser.ins_name}&${selUser.group_name}删除授权成功`,
          type: 'success'
        })
      }).catch(res => {
        this.$swMessage({
          message: res,
          type: 'error'
        })
      })
    },
    // 显示增加用户侧边栏
    show_add_org_panel () {
      this.show_add = true
      this.$set(this.data, 'keys', ['用户组', '组织机构'])
      this.$set(this.data, 'nav_list3', [[], []])
      this.get_user_group_list()
      this.get_institution_tree()
    },
    // 添加授权
    add_athu () {
      if (this.arr_org_ug.length === 0) {
        return
      }
      var json = { ogs: [], users: [], groups: [] }
      if (this.arr_org_ug) {
        this.arr_org_ug.forEach(o => {
          var oru = {
            orgId: o.org.id,
            orgName: o.org.title,
            roleId: o.role.id,
            roleName: o.role.title
          }
          json.ogs.push(oru)
        })
      }
      json.appId = this.$route.params.fid
      var param = { json: JSON.stringify(json) }
      this.btn_loading = true
      service.post('/v1/appAccess/accessAuth', param).then(res => {
        this.btn_loading = false
        this.arr_org_ug = []
        this.clear_search()
        this.show_add = false
        this.$swMessage({
          message: `添加授权成功`,
          type: 'success'
        })
      }).catch(err => {
        this.$swMessage({
          message: err,
          type: 'error'
        })
      })
    },
    // 获取用户组
    get_user_group_list () {
      var param = {
        limit: 1000,
        page: 1
      }
      service.get('/v1/role/showRoleList', { params: param }).then(res => {
        res.data.forEach(d => {
          d.title = d.roleName
        })
        this.user_group_list = res.data
        this.data.nav_list3[0] = res.data
        if (this.data.nav_list3[1]) {
          this.show_org = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取组织机构
    get_institution_tree () {
      this.org_sel_disabled = true
      service.get('/v1/institution/getInstitutionTreeData').then(res => {
        this.data.nav_list3[1] = res
        if (this.data.nav_list3[0]) {
          this.show_org = true
        }
        this.org_sel_disabled = false
      }).catch((err) => {
        console.log(err)
      })
    },
    // 组织机构树形目录点击节点
    node_click (data) {
      this.sw3_select.zj = data.title
      this.org_ug.org = data
      this.show_tree = false
      this.$refs.opt_1.visible = false
      if (this.sw3_select.ug) {
        this.push_org_role()
      }
    },
    // 选择框显示
    visible_change (bool) {
      this.show_tree = bool
    },
    // 选择框选择
    chang_user_group (data) {
      this.data.nav_list3[0].some((d) => {
        if (d.id === data) {
          this.org_ug.role = d
          return true
        }
      })
      if (this.sw3_select.zj) {
        this.push_org_role()
      }
    },
    // 选择用户组及组织机构
    push_org_role () {
      if (!this.org_ug.org || !this.org_ug.role) {
        return
      }
      if (this.arr_org_ug) {
        var same = this.arr_org_ug.some((a) => {
          if (this.org_ug.org.id === a.org.id && this.org_ug.role.id === a.role.id) {
            this.$swMessage({
              message: '存在相同内容',
              type: 'error'
            })
            return true
          }
        })
        if (same) {
          return
        }
      }
      this.arr_org_ug.push(this.org_ug)
      this.org_ug = { org: '', role: '' }
      this.sw3_select = { zj: '', ug: '' }
      this.show_add_org_role = false
    },
    // 删除应用组及组织机构
    del_org_role (index) {
      this.arr_org_ug.splice(index, 1)
    },
    // 搜索组织机构和用户组（已授权列表）
    search_handle () {
      this.keyword_has = this.keyword_has
      this.show_has_tab = false
      this.get_has_org(1)
    },
    // 清空搜索项
    clear_search () {
      this.show_has_tab = false
      this.get_has_org(1)
    }
  }
}
</script>
<style lang="scss" scoped>
.mgt-20 {
  margin-top: 20px !important;
}
.org-tab {
  width: 100;
  margin-bottom: 100px;
  table {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid rgba(225, 228, 230, 1);
    border-top: none;
    border-bottom: none;
    border-collapse: collapse;
    tr {
      width: 100%;
      text-align: left;
      th {
        border-top: 1px solid rgba(225, 228, 230, 1);
      }
      th,
      td {
        display: inline-block;
        height: 36px;
        line-height: 36px;
        padding-left: 16px;
        font-size: 12px;
        font-weight: 500;
        color: rgba(98, 111, 121, 1);
        border-right: 1px solid rgba(225, 228, 230, 1);
        border-bottom: 1px solid rgba(225, 228, 230, 1);
        vertical-align: top;
      }
      td {
        color: rgba(39, 56, 70, 1);
      }
      th:last-child,
      td:last-child {
        border-right: none;
        padding-left: 0;
        div {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .org-select {
    display: flex;
    align-items: center;
    height: 40px;
    border: 1px solid rgba(225, 228, 230, 1);
    border-top: none;
    .org-select-cell {
      padding: 4px 8px;
      width: 47%;
      border-right: 1px solid rgba(225, 228, 230, 1);
      .el-select {
        width: 100% !important;
      }
    }
    .non-first {
      .el-select {
        .el-select-dropdown__item {
          display: none;
        }
      }
    }
    span {
      width: 6%;
      font-size: 12px;
      line-height: 36px;
      text-align: center;
      color: rgba(51, 148, 225, 1);
      cursor: pointer;
    }
  }
}
.sea-lab {
  width: 300px;
  display: flex;
  justify-content: cneter;
  align-items: center;
  .el-row {
    flex: 1;
  }
  .sw-button {
    margin-left: 8px !important;
  }
}
</style>
